import type { Components } from '@mui/material';
import { horizonTheme } from './horizon-theme';

export const muiTabs: Components<typeof horizonTheme>['MuiTabs'] = {
  styleOverrides: {
    root: {
      minHeight: 0,
      height: '38px',
      marginBottom: 36,
    },
    indicator: ({ theme }) => {
      return {
        backgroundColor: theme.palette.red.main,
      };
    },
  },
};
